import { render, staticRenderFns } from "./ContactTypeDashboard.vue?vue&type=template&id=6612fe13&scoped=true&"
import script from "./ContactTypeDashboard.vue?vue&type=script&lang=js&"
export * from "./ContactTypeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6612fe13",
  null
  
)

export default component.exports